export default __webpack_public_path__ + "static/media/worldtrip-logo.9f74f8ae.png";